import { type FC } from 'react';
import { AnimatePresence } from 'framer-motion';

import { selectCurrentLotteryWinnerList } from '@/redux/selectors/lotterySelector';
import { useAppSelector } from '@/redux/store';

import { WinnerItem } from '../WinnerItem/WinnerItem';

const WinnersList: FC = () => {
  const winnerList = useAppSelector(selectCurrentLotteryWinnerList);

  return (
    <div className="w-full flex flex-col gap-[2px]">
      <AnimatePresence>
        {winnerList?.map((props) => (
          <WinnerItem key={props.ticket} {...props} />
        ))}
      </AnimatePresence>
    </div>
  );
};

export { WinnersList };
